import { lazy } from 'react';

import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'components/AuthGuard';

const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const TourList = Loadable(lazy(() => import('pages/tours/TourList')));
const TourForm = Loadable(lazy(() => import('pages/tours/TourForm')));
const TourParticipants = Loadable(lazy(() => import('pages/tours/TourParticipants')));
const TourPayments = Loadable(lazy(() => import('pages/tours/TourPayments')));
const TourPipeline = Loadable(lazy(() => import('pages/tours/TourPipeline')));
const TourMap = Loadable(lazy(() => import('pages/tours/TourMap')));
const TelegramImport = Loadable(lazy(() => import('pages/telegram/TelegramImport')));
const TelegramTemplates = Loadable(lazy(() => import('pages/telegram/TelegramTemplates')));
const VKImport = Loadable(lazy(() => import('pages/vk/VKImport')));
const DriverList = Loadable(lazy(() => import('pages/drivers/DriverList')));
const ParticipantList = Loadable(lazy(() => import('pages/participants/ParticipantList')));
const ParticipantProfile = Loadable(lazy(() => import('pages/participants/ParticipantProfile')));
const AdminList = Loadable(lazy(() => import('pages/admins/AdminList')));
const RolesList = Loadable(lazy(() => import('pages/roles/RolesList')));
const ProPage = Loadable(lazy(() => import('pages/pro/ProPage')));
const LocationList = Loadable(lazy(() => import('pages/locations/LocationList')));
const LocationForm = Loadable(lazy(() => import('pages/locations/LocationForm')));
const LocationView = Loadable(lazy(() => import('pages/locations/LocationView')));
const LoginHistory = Loadable(lazy(() => import('pages/statistics/LoginHistory')));
const OperationLog = Loadable(lazy(() => import('pages/statistics/OperationLog')));

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'tours',
      element: <TourList />
    },
    {
      path: 'tours/new',
      element: <TourForm />
    },
    {
      path: 'tours/:id/edit',
      element: <TourForm />
    },
    {
      path: 'tours/:id/participants',
      element: <TourParticipants />
    },
    {
      path: 'tours/:id/payments',
      element: <TourPayments />
    },
    {
      path: 'tours/:id/pipeline',
      element: <TourPipeline />
    },
    {
      path: 'pipeline',
      element: <TourPipeline />
    },
    {
      path: 'map',
      element: <TourMap />
    },
    {
      path: 'drivers',
      element: <DriverList />
    },
    {
      path: 'participants',
      element: <ParticipantList />
    },
    {
      path: 'participants/:id',
      element: <ParticipantProfile />
    },
    {
      path: 'telegram',
      element: <TelegramImport />
    },
    {
      path: 'vk',
      element: <VKImport />
    },
    {
      path: 'admins',
      element: <AdminList />
    },
    {
      path: 'roles',
      element: <RolesList />
    },
    {
      path: 'telegram/templates',
      element: <TelegramTemplates />
    },
    {
      path: 'locations',
      element: <LocationList />
    },
    {
      path: 'locations/new',
      element: <LocationForm />
    },
    {
      path: 'locations/:id/edit',
      element: <LocationForm />
    },
    {
      path: 'locations/:id',
      element: <LocationView />
    },
    {
      path: 'pro',
      element: <ProPage />
    },
    {
      path: 'statistics/login-history',
      element: <LoginHistory />
    },
    {
      path: 'statistics/operation-log',
      element: <OperationLog />
    }
  ]
};

export default MainRoutes;
